import { Badge } from '@nexelem/components';
import { FormSelectInput } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../../../../hooks';
import { useAvailableQueues } from '../../../../../../queryHooks/useAvailableQueues';

type QueuesSelectInputProps = {
  taskId: number;
};

export const QueuesSelectInput = ({ taskId }: QueuesSelectInputProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.addToPlanForm.queueSelectInput');
  const { data } = useAvailableQueues(taskId.toString());

  const options = data?.queues || [];

  return (
    <FormSelectInput
      required
      getOptionLabel={({ name }) => name}
      isOptionEqualToValue={(option, value) => option.queueId === value.queueId}
      label={tWrapper('queueName')}
      maxWidth={560}
      name="queue"
      options={options}
      placeholder={tWrapper('queueNamePlaceholder')}
      renderOption={(props, option) => (
        <li {...props} key={option.queueId}>
          <div className="flex gap-2">
            <span className="text-s16">{option.name}</span>
            {option.queueId === data?.suggestedQueueId && <Badge variant="highlighted">{tWrapper('suggested')}</Badge>}
          </div>
        </li>
      )}
    />
  );
};
